import _Toast from "@kibt/meta-ui/es/toast";
import _Popup from "@kibt/meta-ui/es/popup";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { computed, defineComponent } from '@vue/composition-api';
import useStore from '../store';
var TYPE;

(function (TYPE) {
  TYPE[TYPE["DISABLE_RECEIVE"] = 0] = "DISABLE_RECEIVE";
  TYPE[TYPE["CAN_RECEIVE"] = 1] = "CAN_RECEIVE";
  TYPE[TYPE["RECEIVED"] = 2] = "RECEIVED";
})(TYPE || (TYPE = {}));

export default defineComponent({
  components: {
    MPopup: _Popup
  },
  setup: function setup(props, ctx) {
    var store = useStore();

    var toGotGift = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store.sendClickLog('PRESENT_PENDANT');
                store.sendBlackCustomLog('clickToGift');
                store.toReceiveAward();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function toGotGift() {
        return _ref.apply(this, arguments);
      };
    }();

    var type = computed(function () {
      // 领取过
      if (store.currentAwardStatus === 1) {
        return 2;
      } // 可领取(打卡完)


      if (store.allBrowesed) {
        return 1;
      } // 不可领取


      return 0;
    });
    var typeMap = computed(function () {
      var _ref2;

      return _ref2 = {}, _defineProperty(_ref2, TYPE.DISABLE_RECEIVE, {
        desc: ['Poderá receber um presente ', 'temático do evento após visitar as ', "quatro exposi\xE7\xF5es, \n                    volte \xE0 p\xE1gina", ' para continuar com sua visita'],
        showHashtag: false,
        buttonText: 'Receber',
        buttonDisable: true,
        buttonBackground: '#D8D8D8',
        buttonColor: '#000',
        toastText: 'Tenta mais tarde'
      }), _defineProperty(_ref2, TYPE.CAN_RECEIVE, {
        desc: ['Parabéns! Você visitou as quatro ', "exibi\xE7\xF5es, \n                    receba a moldura de", ' avatar edição limitada da'],
        showHashtag: true,
        buttonText: 'Receber',
        buttonDisable: false,
        buttonBackground: store.activeVenue ? store.activeVenue.buttonBackground : '',
        buttonColor: '#000'
      }), _defineProperty(_ref2, TYPE.RECEIVED, {
        desc: ['A moldura já está disponível na ', 'sua conta, verifique no perfil'],
        showHashtag: false,
        buttonText: 'Recebido',
        buttonDisable: true,
        buttonBackground: '#000',
        buttonColor: '#FFF'
      }), _ref2;
    });
    var currentTypeValue = computed(function () {
      return typeMap.value[type.value];
    });

    var handleGiftReceiveButtonClick = function handleGiftReceiveButtonClick() {
      if (currentTypeValue.value.toastText) {
        _Toast.show({
          text: currentTypeValue.value.toastText
        });
      }

      if (currentTypeValue.value.buttonDisable) {
        return;
      }

      toGotGift();
    }; // 因为做了个优化，在未开放时，蒙层上滑动还是可以触发下面swiper的，所以设置了pointer-events:none，这里就得处理


    var handleGiftClick = function handleGiftClick() {
      if (!store.activeVenueOpen) {
        return;
      }

      store.changeGiftPopupVisible(true);
      store.sendBlackCustomLog('clickShowGift');
    };

    return {
      store: store,
      toGotGift: toGotGift,
      currentTypeValue: currentTypeValue,
      handleGiftClick: handleGiftClick,
      handleGiftReceiveButtonClick: handleGiftReceiveButtonClick
    };
  }
});